import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  copyLandingPageError,
  copyLandingPageSuccess,
  deleteLandingPageError,
  deleteLandingPageSuccess,
  fetchLandingPagesError,
  fetchLandingPagesSuccess,
} from './actions'
import {
  COPY_LANDING_PAGE_ASYNC,
  DELETE_LANDING_PAGE_ASYNC,
  LANDING_PAGES_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
} from './constants'

const fetchLandingPagesEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      LANDING_PAGES_REQUEST_ASYNC.INITIATE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DELETE_LANDING_PAGE_ASYNC.SUCCESS,
      COPY_LANDING_PAGE_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.awarenessCenter.landingpage)
      return true
    })
    .mergeMap(() =>
      api.awarenessCenter
        .fetchLandingPages(
          store.getState().awarenessCenter.landingPages.page || 1,
          store.getState().awarenessCenter.landingPages.search,
          store.getState().partnerOptions.selectedCompany?.value,
          !!store.getState().app.data.partner
        )
        .mergeMap((response) => Observable.of(fetchLandingPagesSuccess(response)))
        .catch((error) => Observable.of(epicsErrorHandler(fetchLandingPagesError, error)))
        .takeUntil(action$.ofType(LANDING_PAGES_REQUEST_ASYNC.CANCEL))
    )

const deleteLandingPageEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_LANDING_PAGE_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .deleteLandingPage(action.payload.id)
      .map((response) => deleteLandingPageSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(deleteLandingPageError, error)))
      .takeUntil(action$.ofType(DELETE_LANDING_PAGE_ASYNC.CANCEL))
  )

const copyLandingPageEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(COPY_LANDING_PAGE_ASYNC.INITIATE).mergeMap((action) =>
    api.awarenessCenter
      .copyLandingPage(action.payload.id, action.payload.companiesIds)
      .map((response) => copyLandingPageSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(copyLandingPageError, error)))
      .takeUntil(action$.ofType(COPY_LANDING_PAGE_ASYNC.CANCEL))
  )

export default combineEpics(fetchLandingPagesEpic, deleteLandingPageEpic, copyLandingPageEpic)
